export default {
	chinese: '简体中文',
	english: 'English',
	japanese: '日本語',
	french: 'Français',
	title: 'Log in with Oscar',
};
